import successImg from '@images/success.png'
import { Layer, LayerExtendedProps, LayerPositionType, Text } from 'grommet'
import { CSSProperties, ReactNode } from 'react'
import { IModalHeader, ModalHeader } from '../common/Modal/ModalHeader'

type Props = {
  onClose: () => void
  title: string
  children: ReactNode
  style?: CSSProperties
  position?: LayerPositionType
  reset?: () => void
  guide?: {
    top: number
    left: number
    minWidth?: string
  }
} & LayerExtendedProps &
  IModalHeader

export const Modal = ({
  children,
  onClose,
  style,
  title,
  position = 'center',
  reset,
  guide,
  onEdit,
  onDelete,
  ...rest
}: Props) => {
  const handleClose = () => {
    onClose()
    reset && reset()
  }

  return (
    <Layer
      margin={{ vertical: '8px' }}
      modal
      onClickOutside={handleClose}
      onEsc={handleClose}
      position={position}
      style={{ borderRadius: '15px', overflow: 'hidden' }}
      {...rest}
    >
      <div
        className="md:max-h-[88vh] flex flex-col flex-1 overflow-auto w-full md:max-w-[calc(100vw-1.5rem)]"
        style={{
          minWidth: guide?.minWidth || 'min(450px, calc(100vw - 1.5rem))',
          ...(guide
            ? {
                left: `${guide.left}px`,
                position: 'fixed',
                top: `${guide.top}px`,
                zIndex: 2000
              }
            : {}),
          ...style
        }}
      >
        <ModalHeader onClose={handleClose} onDelete={onDelete} onEdit={onEdit} title={title} />
        {children}
      </div>
    </Layer>
  )
}

type SuccessProps = {
  onClose: () => void
  title?: string
  description?: string
  children?: ReactNode
}

export const SuccessModal = ({ onClose, description, title, children }: SuccessProps) => {
  return (
    <Layer
      margin={{ vertical: '8px' }}
      modal
      onClickOutside={onClose}
      onEsc={onClose}
      position="center"
      style={{ borderRadius: '8px', overflow: 'hidden' }}
    >
      <div className="flex max-h-[88vh] w-[min(471px,calc(100vw-1.5rem))] flex-col gap-8 px-6 py-12">
        <div className="flex items-center justify-center">
          <img alt="" className="h-[115px] w-[115px]" src={successImg} />
        </div>
        <div className="flex flex-col gap-5 text-center">
          <Text color="#141414" size="24px" weight={500}>
            {title}
          </Text>
          <Text color="#4F4F4F">{description}</Text>
        </div>
        <div>{children}</div>
      </div>
    </Layer>
  )
}
